var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusIgnore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2583",
    "data-name": "Groupe 2583",
    transform: "translate(-1875 -496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prohibit",
    transform: "translate(1879 500)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-14790-5689.251a8.762,8.762,0,0,1,8.749-8.749,8.763,8.763,0,0,1,8.753,8.749,8.764,8.764,0,0,1-8.753,8.752A8.763,8.763,0,0,1-14790-5689.251Zm1.5,0a7.26,7.26,0,0,0,7.249,7.253,7.261,7.261,0,0,0,7.253-7.253,7.258,7.258,0,0,0-7.253-7.249A7.257,7.257,0,0,0-14788.5-5689.251Zm11.21,5.018-8.976-8.975a.751.751,0,0,1,0-1.062.752.752,0,0,1,1.058,0l8.979,8.975a.758.758,0,0,1,0,1.062.746.746,0,0,1-.531.219A.733.733,0,0,1-14777.291-5684.233Z",
    transform: "translate(14789.25 5697.25)",
    fill: "#e9540d"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2357",
    "data-name": "Rectangle 2357",
    width: 24,
    height: 24,
    transform: "translate(1875 496)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIgnore);
export default __webpack_public_path__ + "static/media/status-ignore.c65e723ad4922d6e26cc5830e5716f99.svg";
export { ForwardRef as ReactComponent };